import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100vh;
`

export const Section = styled.section`
  width: 100%;
  display: flex;
  align-items: flex-end;
`

export const Center = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex: 1;
`

export const SectionTerms = styled.div`
  flex: 1;
  display: flex;
  gap: 15px;
  align-items: flex-end;
`

export const Article = styled.article``

export const Buttons = styled.div`
  width: 300px;
  display: flex;
  justify-content: center;
`
